<template>
  <KTCodePreview v-bind:title="'Thông tin phiếu nhập kho đầu kỳ'">
    <template v-slot:toolbar>
      <div class="row" v-if="stockSlip.id">
        <div>
          <b-row
            class="mb-4 ml-4"
            style="vertical-align: middle; display: inline"
          >
            <EditToggle
              v-if="stockSlip.id"
              v-model="isEdit"
              id="customSwitch2"
              label="Chỉnh sửa"
            />
          </b-row>
        </div>
      </div>
    </template>
    <template v-slot:preview>
      <StockSlipSkeleton
        :renderComponent="renderComponent"
        v-if="!renderComponent"
      />
      <div v-if="renderComponent">
        <b-row class="mb-5 col-12 mb-1 m-0 p-0" v-if="stockSlip.code">
          <label class="font-weight-bold"
            >Mã phiếu kho:
            <a class="text-primary">{{ stockSlip.code }}</a></label
          >
        </b-row>
        <b-row class="mb-5 col-6 mb-1 m-0 p-0">
          <StockSlipOpening
            :stockSlip="stockSlip"
            :stores="filteredOptions"
            @onSelectedSourceWarehouse="onSelectedSourceWarehouse"
            @onInputChangeSourceWarehouse="onInputChangeSourceWarehouse"
            :editable="isEdit"
          />
        </b-row>
        <b-row class="mb-5 col-12 mb-1 m-0 p-0">
          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-secondary font-weight-bolder btn-sm"
              @click="showModalImportProduct"
              :disabled="!isEdit"
            >
              <i style="font-size: 1rem" class="far fa-file-excel"></i>Nhập SP
              từ excel
            </button>
          </div>
        </b-row>
        <b-table
          v-if="isError"
          bordered
          hover
          :fields="errorFields"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
        >
        </b-table>
        <b-table
          v-else
          bordered
          hover
          :fields="fields"
          :items="stockSlip.details"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:cell(productName)="row">
            <ProductCommonInfo :product="row.item" />
          </template>
          <template v-slot:cell(actions)="row">
            <v-icon
              small
              class="text-danger"
              @click="deleteItemInArray(row.item.id)"
              v-b-tooltip
              title="Xóa"
              >mdi-delete</v-icon
            >
          </template>
        </b-table>
        <div class="d-flex justify-content-end mt-3" v-if="totalRows">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            align="right"
            size="sm"
          />
        </div>
        <b-modal
          ref="import-product-modal"
          hide-footer
          title="Thêm sản phẩm từ Excel"
          id="modal-prevent-closing"
          size="lg"
        >
          <b-row>
            <b-col>
              <div class="form-group">
                <span>
                  <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
                  đúng format, hoặc có thể tải ở
                  <a :href="urlExcel">đây</a>
                </span>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <span> <b>Bước 2:</b> Tiến hành Import </span>
              <div style="padding-top: 15px">
                <b-form-file
                  placeholder="Hãy chọn một tập tin"
                  @change="selectFile"
                  v-model="file"
                  ref="file-input"
                  class="mb-2"
                ></b-form-file>
              </div>
            </b-col>
          </b-row>
          <b-button
            style="font-weight: 600; width: 70px"
            variant="primary"
            size="sm"
            @click="validData"
            >Lưu</b-button
          >
          <b-button
            style="margin-left: 10px; font-weight: 600; width: 70px"
            variant="secondary"
            size="sm"
            @click="hideModalImportProduct"
            >Hủy</b-button
          >
        </b-modal>
      </div>
    </template>
    <template v-slot:foot>
      <b-button
        style="font-weight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        :disabled="!isEdit || isError"
        >Lưu</b-button
      >
      <router-link to="/opening-stock-receipt" tag="button">
        <b-button
          style="margin-left: 10px; font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          >Hủy</b-button
        >
      </router-link>
    </template>
  </KTCodePreview>
</template>

<script>
import apiCommonMixin from '@/view/mixins/api-common.mixins.js';
import ApiService from '@/core/services/api.service';
import KTCodePreview from '@/view/content/CodePreview.vue';
import moment from 'moment';
import {
  makeToastFaile,
  makeToastSuccess,
  xoa_dau,
  convertPrice,
} from '@/utils/common';
import { URL_IMPORT_PRODUCT_PRINT } from '@/utils/constants';
import xlsx from 'xlsx';
import { v4 } from 'uuid';
import StockSlipSkeleton from '../../../components/stock-slips/StockSlipSkeleton.vue';
import StockSlipOpening from '../../../components/stock-slips/StockSlipOpening.vue';
import EditToggle from '@/view/components/common/EditToggle.vue';
import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue';

export default {
  mixins: [apiCommonMixin],
  data() {
    return {
      stockSlip: {
        id: null,
        code: '',
        type: 49,
        sourceWarehouseName: '',
        sourceWarehouseId: null,
        destinationWarehouseName: '',
        destinationWarehouseId: null,
        relatedStockSlipId: null,
        relatedStockSlipCode: '',
        notes: '',
        details: [],
      },
      filteredOptions: [],
      stores: [],
      isSubmitting: false,
      renderComponent: true,
      isEdit: false,
      importItems: [],
      excellist: [],
      urlExcel: URL_IMPORT_PRODUCT_PRINT,
      currentPage: 1,
      perPage: 30,
      isError: false,
      errorFields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '4%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'message',
          label: 'Lỗi',
        },
      ],
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '4%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá',
          formatter: (value) => {
            return convertPrice(value);
          },
          tdClass: 'text-right',
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          formatter: (value) => {
            return convertPrice(value);
          },
          tdClass: 'text-right',
        },
        {
          key: 'actions',
          label: '',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '4%',
          },
        },
      ],
      items: [],
      file: null,
    };
  },
  components: {
    KTCodePreview,
    StockSlipSkeleton,
    StockSlipOpening,
    EditToggle,
    ProductCommonInfo,
  },
  async created() {
    this.filteredOptions = [];
    const { stores, currentStoreId, currentStoreName } =
      await this.fetchStoreByUser();
    this.stores = stores;
    this.filteredOptions = [...this.stores];
    if (currentStoreId && !this.stockSlip.sourceWarehouseId) {
      this.stockSlip.sourceWarehouseId = currentStoreId;
      this.stockSlip.sourceWarehouseName = currentStoreName;
    }
    this.stockSlip.id = this.$route.query?.id || null;
    if (this.stockSlip.id) {
      await this.getStockSlipByID();
    } else {
      this.isEdit = true;
    }
  },
  computed: {
    totalRows() {
      if (this.isError) {
        return this.items.length;
      }
      return this.stockSlip.details.length;
    },
  },
  methods: {
    createStockSlip: async function () {
      const details = this.stockSlip.details.map((element) => {
        return {
          productId: element.productId,
          quantity: element.quantity,
          unitPrice: element.unitPrice || 0,
        };
      });
      const payload = {
        sourceWarehouseId: this.stockSlip.sourceWarehouseId,
        stockSlipDate: this.stockSlip.stockSlipDate
          ? moment(this.stockSlip.stockSlipDate, 'DD/MM/YYYY').format(
              'yyyy-MM-DD',
            )
          : null,
        description: this.stockSlip.notes,
        stockSlipType: this.stockSlip.type,
        details,
      };
      if (!payload.sourceWarehouseId) {
        this.isSubmitting = false;
        return makeToastFaile('Vui lòng chọn kho nhập!');
      }
      if (!payload.stockSlipDate) {
        this.isSubmitting = false;
        return makeToastFaile('Vui lòng chọn ngày nhập kho!');
      }

      try {
        const res = await ApiService.post(
          'v1/opening-stock-slip',
          payload,
        ).catch((error) => {
          this.isSubmitting = false;
          const message = error?.response?.data?.message || 'Lỗi!';
          makeToastFaile(message);
        });
        makeToastSuccess(res.data.message);
        this.$router.push({
          name: 'opening-stock-receipt-list',
        });
      } catch ({ response }) {
        makeToastFaile(response.$error);
      } finally {
        this.isSubmitting = false;
      }
    },
    updateStockSlip: async function () {
      const details = this.stockSlip.details.map((element) => {
        return {
          id: element.id,
          productId: element.productId,
          quantity: element.quantity,
          unitPrice: element.unitPrice || 0,
        };
      });
      const payload = {
        id: this.stockSlip.id,
        sourceWarehouseId: this.stockSlip.sourceWarehouseId,
        stockSlipType: this.stockSlip.type,
        stockSlipDate: this.stockSlip.stockSlipDate
          ? moment(this.stockSlip.stockSlipDate, 'DD/MM/YYYY').format(
              'yyyy-MM-DD',
            )
          : null,
        description: this.stockSlip.notes,
        details,
      };
      if (!payload.sourceWarehouseId) {
        this.isSubmitting = false;
        return makeToastFaile('Vui lòng chọn kho chuyển!');
      }
      try {
        const res = await ApiService.put('v1/opening-stock-slip', payload);
        makeToastSuccess(res.data.message);
        this.$router.push({
          name: 'opening-stock-receipt-list',
        });
      } catch ({ response }) {
        makeToastFaile(response.$error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      if (!this.stockSlip.id) {
        this.createStockSlip();
        return;
      }
      this.updateStockSlip();
    },
    onSelectedSourceWarehouse(option) {
      this.stockSlip.sourceWarehouseName = option.item.name;
      this.stockSlip.sourceWarehouseId = option.item.id;
    },
    onInputChangeSourceWarehouse(text) {
      this.stockSlip.sourceWarehouseName = text;
      const filteredData = this.stores
        .filter((item) => {
          return (
            xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.filteredOptions = [...filteredData];
    },
    onSelectedDestinationWarehouse(option) {
      this.stockSlip.destinationWarehouseName = option.item.name;
      this.stockSlip.destinationWarehouseId = option.item.id;
    },
    onInputChangeDestinationWarehouse(text) {
      this.stockSlip.destinationWarehouseName = text;
      const filteredData = this.stores
        .filter((item) => {
          return (
            xoa_dau(item.name).toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          );
        })
        .slice(0, 10);
      this.filteredOptions = [...filteredData];
    },
    getStockSlipByID: async function () {
      this.renderComponent = false;
      ApiService.get(
        `v1/transfer-stock-slips/request/${this.stockSlip.id}`,
      ).then((data) => {
        const stockSlipData = data.data.data;
        this.stockSlip.code = stockSlipData.code;
        this.stockSlip.sourceWarehouseId = stockSlipData.sourceWarehouseId;
        this.stockSlip.sourceWarehouseName = stockSlipData.sourceWarehouseName;
        this.stockSlip.stockSlipDate = stockSlipData.stockSlipDate
          ? moment(stockSlipData.stockSlipDate).format('DD-MM-YYYY')
          : '';
        this.stockSlip.notes = stockSlipData.description;
        this.stockSlip.details = stockSlipData.details.map((detail, index) => {
          return {
            ...detail,
            count: index + 1,
            unitPrice: detail.unitPrice,
          };
        });
        this.renderComponent = true;
      });
    },
    showModalImportProduct() {
      this.importItems = [];
      this.excellist = [];
      this.$refs['import-product-modal'].show();
    },
    deleteItemInArray(productId) {
      for (var i = 0; i < this.stockSlip.details.length; i++) {
        if (this.stockSlip.details[i].id === productId) {
          this.stockSlip.details.splice(i, 1);
        }
      }
    },
    selectFile(event) {
      this.importItems = [];
      const files = event.target.files[0];
      this.file = files;
      if (!files) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.file = null;
        this.clearFiles();
        return alert(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls hoặc .xlsx',
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: 'binary',
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {
            blankRows: false,
          }); // Generate JSON table content，wb.Sheets Get the data of the first sheet
          const excellist = []; // Clear received data
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          } // At this point, you get an array containing objects that need to be processed
          this.excellist = excellist;
          this.excellist.map((element) => {
            const productItem = {
              productCode: element['Mã hàng'] ? element['Mã hàng'] : '',
              productName: element['Tên hàng'] ? element['Tên hàng'] : '',
              quantity: element['Tổng cộng'] ? element['Tổng cộng'] : 0,
              unitPrice: element['Giá vốn'] ? element['Giá vốn'] : 0,
            };
            this.importItems.push(productItem);
          });
        } catch (e) {
          return alert('Read failure!');
        }
      };
      fileReader.readAsBinaryString(files);
    },
    clearFiles() {
      this.$refs['file-input'].reset();
    },
    hideModalImportProduct() {
      this.$refs['import-product-modal'].hide();
    },
    mapImportData(importItems) {
      for (const item of importItems) {
        const stockSlipDetail = this.stockSlip.details.find(
          (detail) => detail.productId === item.productId,
        );
        if (stockSlipDetail) {
          stockSlipDetail.unitPrice = item.unitPrice;
        } else {
          this.stockSlip.details.push({
            id: v4(),
            ...item,
            count: this.stockSlip.details.length + 1,
          });
        }
      }
    },
    validData() {
      const data = {
        listProduct: this.importItems,
      };
      ApiService.post('v1/opening-stock-slip/validate-import-product', data)
        .then((response) => {
          const { status, message, data: result } = response.data.data;
          if (status === 1) {
            this.isError = false;
            makeToastSuccess(message);
            this.mapImportData(result);
          } else {
            this.isError = true;
            makeToastFaile(message);
            this.items = result.map((item, index) => {
              return {
                id: v4(),
                message: item,
                count: index + 1,
              };
            });
          }
        })
        .catch((err) => {
          this.isError = true;
          const message = err.response.data.message;
          makeToastFaile(message);
        });
      this.$refs['import-product-modal'].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-header {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}
.orderCode:hover {
  text-decoration: underline;
}
</style>
